import { useEffect } from "react";

import { pwaUpdateStore } from "./pwaUpdateStore";

function applyIfPending(): void {
  if (pwaUpdateStore.getState() !== "none") pwaUpdateStore.apply();
}

/** Applies a pending version now and every one that arrives until the returned unsubscribe is called. */
export function applyPwaUpdatesAsTheyArrive(): () => void {
  applyIfPending();
  return pwaUpdateStore.subscribe(applyIfPending);
}

// Signed-out screens hold no payment a reload could drop, and an outdated build there may miss what the API now requires.
export function useApplyPwaUpdateNow(): void {
  useEffect(() => applyPwaUpdatesAsTheyArrive(), []);
}
